export default __webpack_public_path__ + "static/media/1.48debc24.jpg";